import { Box, Typography, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import { alpha } from "../../theme/tokens";
import { useDesignTokens } from "../../context/ThemeContext";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import PipeSpecificationsTable from "./PipeSpecificationsTable";

const ERROR_VARIABLE_MAP = {
    W22: { label: "Cálculo de Tubagens: Vapor Desgasificação", isPipeError: true, showMessage: true },
    W24: { label: "Cálculo de Tubagens: Vapor Aquecimento", isPipeError: true, showMessage: true },
    W27: { label: "Cálculo de Tubagens: Vapor Pemutador Calor", isPipeError: true, showMessage: true },
    W30: { label: "Cálculo de Tubagens: Entrada Vapor Flash", isPipeError: true, showMessage: true },
    M21: { label: "Cálculo de Tubagens: Alimentação Caldeiras", isPipeError: true, showMessage: true },
    M26: { label: "Cálculo de Tubagens: Condensados", isPipeError: true, showMessage: true },
    M29: { label: "Cálculo de Tubagens: Água Make-up", isPipeError: true, showMessage: true },
    M32: { label: "Cálculo de Tubagens: Retorno Bombas", isPipeError: true, showMessage: true },

};

const parseErrorVariable = (error) => {
    if (!error) return null;

    const responseData = error.response?.data;
    const errorMessage = responseData?.error || responseData?.message || error.message;

    if (!errorMessage) return null;

    const match = errorMessage.match(/Variable\[(\w+)\]:\s*(.+)/);
    if (match) {
        const code = match[1];
        const detail = match[2].trim();
        const mapped = ERROR_VARIABLE_MAP[code];
        const valueMatch = detail.match(/(\d+(?:\.\d+)?)/);
        return {
            code,
            label: mapped?.label || code,
            detail,
            isPipeError: mapped?.isPipeError || false,
            value: valueMatch ? valueMatch[1] : null,
            showMessage: mapped?.showMessage || false,
        };
    }

    return null;
};

const CalculationWarning = ({ error }) => {
    const { t } = useTranslation();
    const tokens = useDesignTokens();
    const variable = parseErrorVariable(error);
    const showPipeTable = variable?.isPipeError || false;
    const showMessage = variable?.showMessage || false;

    return (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4, px: 2 }}>
            <Paper
                elevation={0}
                sx={{
                    maxWidth: 520,
                    width: "100%",
                    p: 3,
                    borderRadius: 3,
                    border: "1px solid #ffc107",
                    backgroundColor: "transparent",
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
                    <WarningAmberIcon sx={{ fontSize: 28, color: "#ff9800" }} />
                    <Typography variant="h6" sx={{ color: "var(--text-primary)", fontWeight: 700 }}>
                        {t("budgetForm.calculationWarning.title")}
                    </Typography>
                </Box>

                <Typography variant="body2" sx={{ color: "var(--text-secondary)", mb: 2 }}>
                    {t("budgetForm.calculationWarning.subtitle")}
                </Typography>

                {variable && (
                    <>
                        <Box
                            sx={{
                                height: "1px",
                                backgroundColor: "rgba(0,0,0,0.08)",
                                my: 2,
                            }}
                        />

                        <Typography
                            variant="overline"
                            sx={{
                                color: "var(--text-secondary)",
                                fontWeight: 600,
                                letterSpacing: 1,
                                fontSize: "0.7rem",
                                display: "block",
                                mb: 1,
                            }}
                        >
                            DETALHE DO ERRO
                        </Typography>

                        <Box
                            sx={{
                                backgroundColor: alpha.error06,
                                borderLeft: `3px solid ${tokens.error}`,
                                borderRadius: "0 8px 8px 0",
                                p: 1.5,
                            }}
                        >
                            <Typography
                                variant="body2"
                                sx={{
                                    color: "error.dark",
                                    fontWeight: 700,
                                    fontSize: "0.95rem",
                                }}
                            >
                                {variable.label}
                            </Typography>
                            <Typography
                                variant="caption"
                                sx={{
                                    color: "var(--text-secondary)",
                                    display: "block",
                                    mt: 0.5,
                                    lineHeight: 1.4,
                                }}
                            >
                                {variable.detail}
                            </Typography>
                        </Box>

                        {variable.value && showMessage && (
                            <Typography
                                variant="body2"
                                sx={{
                                    color: "#000",
                                    fontWeight: 600,
                                    mt: 2,
                                    mb: 1,
                                }}
                            >
                                Não foi possivel calcular o valor "Diamêtro Adotado" porque o valor {variable.value} mm ultrapassa o máximo de 300 mm definido na tabela.
                            </Typography>
                        )}

                        {showPipeTable && (
                            <PipeSpecificationsTable />
                        )}
                    </>
                )}
            </Paper>
        </Box>
    );
};

export default CalculationWarning;
